import { createRouter, createWebHistory } from 'vue-router'
// import Support from '@/components/Support'
// import Products from '@/components/Products'
// import About from '@/components/About'
// import CBWeb from '@/components/CBWeb'
import Main from '@/components/Main.vue'
import GameIntro from '@/components/GameIntro.vue'

export default createRouter({
    history: createWebHistory(),
    routes: [{
        path: '/',
        component: Main,
    }, {
        path: '/game-intro',
        name: 'game-intro',
        component: GameIntro,
    // }, {
    //     path: '/',
    //     component: Main,
    //     children: [
    //         {
    //             path: 'support',
    //             name: 'support',
    //             component: Support,
    //         }, {
    //             path: 'products',
    //             name: 'products',
    //             component: Products
    //         }, {
    //             path: 'about',
    //             name: 'about',
    //             component: About,
    //         }
    //     ]
    }]
})
